import { useQuery } from 'react-query';

import { getServerTime as queryFn } from 'api/endPoints/getServerTime';
import { QueryKeys } from 'api/queryKeys';

export const useQueryServerTime = () => {
    return useQuery<QueryResponse, QueryError, QueryResponse, QueryKeys>({
        queryKey: 'getServerTime',
        queryFn: () => queryFn(),
        cacheTime: 0,
        placeholderData: {
            time: new Date().valueOf(),
        },
    });
};

interface QueryResponse {
    time: number;
}
